import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-58bf95ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-info"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "user-name"
};
import { computed } from "vue";
import { useStore } from "vuex";
import org from '@/assets/img/org.png';
export default {
  __name: 'UserInfo',
  setup(__props) {
    const store = useStore();
    const orgInfo = computed(() => store.state.home.orgInfo || {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        class: "user-avatar",
        src: orgInfo.value.logoUrl || _unref(org)
      }, null, 8, _hoisted_2), _createElementVNode("span", _hoisted_3, _toDisplayString(orgInfo.value.organizationName), 1)]);
    };
  }
};